import orderTranslationsHelper from "../../../../languages/order-translations.helper";
import {
  OrderAddNotAcceptableResponse,
  OrderAddNotAcceptableResponseErrorType,
  OrderAddUnprocessableEntityResponse,
} from "../../../api/raily/order/add/order-add-response";
import {
  OrderAddDefaultError,
  OrderAddNorAcceptableTimeNotAvailableError,
  OrderAddNotAcceptableError,
  OrderAddNotAcceptableErrorType,
  OrderAddNotAcceptableInconsistentRideTimingError,
  OrderAddNotAcceptableNoValidCargoTaxiContract,
  OrderAddNotAcceptablePassengerDoOverlapError,
  OrderAddNotAcceptableTimingNotPossibleError,
  OrderAddUnprocessableEntityError,
  OrderAddUnprocessableEntityErrorType,
  OrderAddUnprocessableEntityTooLongRideError,
} from "./order-add-error";

const createTooLongRideError =
  (): OrderAddUnprocessableEntityTooLongRideError => {
    const translations =
      orderTranslationsHelper.getAddTranslations().validation;

    return {
      message: translations.errors.unprocessableEntity.givenTimeError,
      params: {},
      type: OrderAddUnprocessableEntityErrorType.TOO_LONG_RIDE,
    };
  };

const createDefaultError = (): OrderAddDefaultError => {
  const translations = orderTranslationsHelper.getAddTranslations().validation;

  return {
    message: translations.defaultError,
    params: {},
    type: OrderAddUnprocessableEntityErrorType.DEFAULT,
  };
};

const createInconsistentRideTimingError =
  (): OrderAddNotAcceptableInconsistentRideTimingError => {
    const translations =
      orderTranslationsHelper.getAddTranslations().validation.errors.api;

    return {
      message: translations.inconsistentRideTimingError,
      params: {},
      type: OrderAddNotAcceptableErrorType.INCONSISTENT_RIDE_TIMING,
    };
  };

const createTimeNotAvailableError =
  (): OrderAddNorAcceptableTimeNotAvailableError => {
    const translations =
      orderTranslationsHelper.getAddTranslations().validation.errors.api;

    return {
      message: translations.timingNotAvailableError,
      params: {},
      type: OrderAddNotAcceptableErrorType.TIME_NOT_AVAILABLE,
    };
  };

const createTimingNotPossibleError =
  (): OrderAddNotAcceptableTimingNotPossibleError => {
    const translations =
      orderTranslationsHelper.getAddTranslations().validation.errors.api;

    return {
      message: translations.timingNotPossibleError,
      params: {},
      type: OrderAddNotAcceptableErrorType.TIMING_NOT_POSSIBLE,
    };
  };

const createNoValidCargoTaxiContract =
  (): OrderAddNotAcceptableNoValidCargoTaxiContract => {
    const translations =
      orderTranslationsHelper.getAddTranslations().validation.errors.api;

    return {
      message: translations.noValidCargoTaxiContractError,
      params: {},
      type: OrderAddNotAcceptableErrorType.NO_VALID_CARGO_TAXI_CONTRACT,
    };
  };

const createPassengerDoOverlapError =
  (): OrderAddNotAcceptablePassengerDoOverlapError => {
    const translations =
      orderTranslationsHelper.getAddTranslations().validation.errors.api;

    return {
      message: translations.passengerDoOverlapError,
      params: {},
      type: OrderAddNotAcceptableErrorType.PASSENGERS_DO_OVERLAP,
    };
  };

const resolveNotAcceptableError = (
  error: OrderAddNotAcceptableResponse,
): OrderAddNotAcceptableError => {
  switch (error.data.errorType) {
    case OrderAddNotAcceptableResponseErrorType.INCONSISTENT_RIDE_TIMING:
      return createInconsistentRideTimingError();
    case OrderAddNotAcceptableResponseErrorType.NO_VALID_CARGO_TAXI_CONTRACT:
      return createNoValidCargoTaxiContract();
    case OrderAddNotAcceptableResponseErrorType.PASSENGERS_DO_OVERLAP:
      return createPassengerDoOverlapError();
    case OrderAddNotAcceptableResponseErrorType.TIME_NOT_AVAILABLE:
      return createTimeNotAvailableError();
    case OrderAddNotAcceptableResponseErrorType.TIMING_NOT_POSSIBLE:
      return createTimingNotPossibleError();
  }
};

const resolveUnprocessableEntityError = (
  error: OrderAddUnprocessableEntityResponse,
): OrderAddUnprocessableEntityError => {
  const [item] = error.data.detail;

  if (item.errorCode) {
    return createTooLongRideError();
  } else {
    return createDefaultError();
  }
};

const orderAddErrorFactory = {
  resolveNotAcceptableError,
  resolveUnprocessableEntityError,
};

export default orderAddErrorFactory;
